<template>
<div class="input_field_wrap animate_class" v-if="data.show_field" :class="inputfieldhightlight" :id="'inputfield_'+data.id">
<div class="grid custom_input_wrap mr-0 ml-0">


<div class="col-12 mb-0">

<div class="grid">



<div class="col-10 md:col-11 py-0" @click="testpoints">
<template v-if="data.inputfieldclasses && data.inputfieldclasses.length">
<Tag   v-for="theclass in data.inputfieldclasses" :value="theclass.name" class="mr-2" :style="'background-color:'+theclass.color"></Tag>
</template>

<template v-if="data.completion">
  <label  class="quiz_label_completed ">{{labeltext}}
    <span class="material-icons md-26 ml-3 text-green-300"    
    v-tooltip.right="{ value: $store.state.languages.lang_phrases.tamamlandi, disabled: false,class: 'custom-top-tooltip' }">
    check_circle
    </span>   
    <template v-if="data.read_only_state">
       <span class="ml-4" v-if="inputfieldpoints || inputfieldpoints===0">{{inputfieldpoints}} {{ $store.state.languages.lang_phrases.puan}}</span>
    </template>
   
</label>
</template>

<template v-if="!data.completion">
  <label  class="quiz_label ">{{labeltext}}
    <template v-if="data.is_required" >
       <span class="material-icons md-26 ml-3 text-yellow-400"      
      v-tooltip.right="{ value: $store.state.languages.lang_phrases.gerekli, disabled: false,class: 'custom-top-tooltip' }">
      emergency
      </span> 
    </template>
    <template v-if="!data.is_required" >
       <span class="material-icons md-26 ml-3 text-cyan-500"      
      v-tooltip.right="{ value: $store.state.languages.lang_phrases.beklemede, disabled: false,class: 'custom-top-tooltip' }">
      mode_standby
      </span> 
    </template>
     
</label>
</template>






</div>




<div class="col-2 md:col-1 py-0"  v-show="helptext">
<div class="flex align-items-center justify-content-end" >
<i class="pi pi-question-circle pr-1 help_tooltip" tabindex="1"  v-tooltip.left.focus="{ value: helptext,fitContent:true,class: 'help-tooltip' }"></i>
</div>
</div>

</div>

</div>


<div :class="leftsideclass">







<template v-if="data.type=='text'">
<TextType :data="data"></TextType>
</template>

<template v-if="data.type=='longtext'">
<LongTextType :data="data"></LongTextType>
</template>

<template v-if="data.type=='number'">
<NumberType :data="data"></NumberType>
</template>

<template v-if="data.type=='select'">  
<SelectType :data="data"></SelectType>
</template>

<template v-if="data.type=='multiselect'">
<MultiselectType :data="data"></MultiselectType>
</template>

<template v-if="data.type=='boolean'">
<BooleanType :data="data"></BooleanType>
</template>

<template v-if="data.type=='columns'">
<ColumnsType :data="data"></ColumnsType>
</template>
<template v-if="data.type=='listselect'">
<ListselectType :data="data"></ListselectType>
</template>

<template v-if="data.type=='listinput'">
<InputFieldType :data="data"></InputFieldType>
</template>





</div>


<div :class="rightsideclass">

<template v-if="data.is_nullable">
<!--read_only_state-->
<template v-if="data.read_only_state">
  <template v-if="data.submissions.length && data.submissions[0].is_nulled">
    <!--<Button :label="$store.state.languages.lang_phrases.bos_birakilmis" class=" p-button-primary p-button-outlined  p-button-sm  ml-1 px-1" :class="function_btn_adjust"  @click="showNullModal" :loading="submitting"></Button>-->
    <div class="flex  mr-2 flex-column">
    <p class=" text-red-500 font-bold p-link pl-1">{{$store.state.languages.lang_phrases.bos_birakilmis}}</p>
    <p class=" text-primary font-bold p-link pl-1" v-if="nullreasonname">{{nullreasonname}}</p>
    </div>


  </template>
</template>
<!--read_only_state-->
<!--active-->
<template v-if="!data.read_only_state">
  <template v-if="data.submissions.length && data.submissions[0].is_nulled">
    <Button :label="$store.state.languages.lang_phrases.alani_cevapla" class=" p-button-primary p-button-outlined  p-button-sm  ml-1 px-1" :class="function_btn_adjust"  @click="reverseNull" :loading="submitting"></Button>
  </template>
  <template v-else>
    <Button :label="$store.state.languages.lang_phrases.bos_gec" class=" p-button-primary p-button-outlined  p-button-sm  ml-1  px-1" :class="function_btn_adjust"  @click="showNullModal" :loading="submitting_null"></Button>
  </template> 
  
</template>
<!--active-->


  
</template>


<template v-if="data.show_evidence_btn">

<!--read_only_state-->
<template v-if="data.read_only_state">
   <Button :label="$store.state.languages.lang_phrases.yuklu_kanitlar" class=" p-button-primary p-button-outlined  p-button-sm mt-1 ml-1 px-1" :class="function_btn_adjust"  @click="showEvidenceModal" :loading="submitting"></Button>
</template>
<!--read_only_state-->
<!--active-->
<template v-if="!data.read_only_state">
  <template v-if="data.submissions[0].evidences.length">
    <Button :label="$store.state.languages.lang_phrases.daha_fazla_kanit_yukle" class=" p-button-primary p-button-outlined  p-button-sm mt-1 ml-1 px-1" :class="function_btn_adjust"  @click="showEvidenceModal" :loading="submitting"></Button>
  </template>
  <template v-else>
    <Button :label="$store.state.languages.lang_phrases.kanit_yukle" class=" p-button-warning p-button-outlined  p-button-sm mt-1 ml-1 px-1" :class="function_btn_adjust"  @click="showEvidenceModal" :loading="submitting"></Button>
  </template>
</template>
<!--active-->





</template>



</div>


<!-- submission note-->
<template v-if="data.ask_for_submission_note">
<template v-if="data.submission_note_show_type=='on_input' && data.show_info_textarea">
<InputfieldNote :data="data"></InputfieldNote>
</template>
<template v-if="data.submission_note_show_type=='always'">
<div class="col-12">
  <InputfieldNote :data="data"></InputfieldNote>
</div>
</template>
</template>
<!-- submission note-->

<div class="col-12 mt-2">
<!-- if has nonconfomity types -->
<template v-if="$store.state.evaluation.nonconformity_types.length">

<!-- admin -->
<!--
<template v-if="usertype=='auditor'">
<hr>
<h4 class="text-primary font-bold">Denetçiye Özel</h4>

<ClickEditInputTextArea :title="$store.state.languages.lang_phrases.denetci_notu" :value="auditor_note"  valkey="auditor_note" @dataChanged="addAuditorNote"  />




</template>
-->
<!-- admin -->


<!-- supplier -->
<template v-if="usertype=='supplier'">
<hr>
<template v-if="data.nonconformity">
<Tag  :style="'background-color:#dd4b39'" :value="data.nonconformity.nonconformitytype.name" ></Tag>
</template>

</template>
<!-- supplier -->





</template>
<!-- if has nonconfomity types -->
</div>




</div>

</div>
</template>

<script>
import TextType from "./TextType"
import LongTextType from "./LongTextType"
import NumberType from "./NumberType"
import SelectType from "./SelectType"
import MultiselectType from "./MultiselectType"
import ColumnsType from "./ColumnsType"
import BooleanType from "./BooleanType"
import ListselectType from "./ListselectType"
import InputFieldType from "./InputFieldType"
import InputfieldNote from "./InputfieldNote"
export default {

  name: 'CustomAuditInputfield',
  props:["data"],
  components:{TextType,LongTextType,NumberType,SelectType,MultiselectType,ColumnsType,BooleanType,ListselectType,InputFieldType,InputfieldNote},
  data () {
    return {
      submitting:false,
      submitting_null:false
    }
  },
  watch:{
    data(newval,oldval)
    {
    },
    finish_error(newval,oldval)
    {
      console.log("finish_error")
      if(newval)
      {
        console.log("newval")
        console.log(this.data)
        if(this.$store.state.evaluation.first_inputfield_error.id ==this.data.id )
        {
          let element = document.getElementById("inputfield_"+this.data.id);
        }
        
        setTimeout(()=>{
          element.scrollIntoView();
          this.$store.dispatch('evaluation/setFinishError',false)
        },100)
        
      }
    }
  },
  computed:{
    nonconformity_color()
    {
      if(this.data.nonconformity)
      {
        console.log("YES NONCONFOMT")
        if(this.data.nonconformity.nonconformitytype.color)
        {
          console.log("YES COLOR")
          return this.data.nonconformity.nonconformitytype.color
        }
        else
        {
          return "#dd4b39"
        }
      }
      else
      {
        return ""
      }
    },
    auditor_note()
    {
      if(this.data.submissions.length)
      {
        return this.data.submissions[0].auditor_note
      }
      else
      {
        return null
      }
    },
    inputfieldpoints()
    {
      if(this.data.results)
      {
        return this.data.results.points
      }
    },
    nullreasonname()
    {
      if(this.data.submissions.length && this.data.submissions[0].null_reason)
      {
        let reasons = this.$store.state.evaluation.nullreasons
        let reason = reasons.find((element)=>{return element.id == this.data.submissions[0].null_reason})
        if(reason)
        {
          if(reason.translations.length)
          {
            let translation = reason.translations.find((item)=>{return item._language_id == this.$store.state.auth.user.preflang_id})
            if(translation)
            {
              return translation.translation
            }
            else
            {
              return reason.name
            }
          }
          return reason.name 
        }
      }
      else
      {
        return null
      }
    },
    usertype()
    {
      let user = this.$store.state.auth.user
      if(user.userroles && user.userroles.length)
      {
        let userroles = user.userroles.map((element)=>{return element.name})
        if(userroles.includes("auditor"))
        {
          return "auditor"
        }

        if(userroles.includes("supplier"))
        {
          return "supplier"
        }
      }
      else
      {
        return "supplier"
      }
    },
    readyforevidences()
    {
      if(!this.data.submissions.length)
      {
        return false
      }
      if(!this.data.is_evindence_required)
      {
        return false
      }
      let submission = this.data.submissions[0]
      //number
      if(this.data.type=="number")
      {
        if(submission.submission_numerical)
        {          
         console.log("readyforevidences")
          return true
        }
        else
        {
          return false
        }
      }
      //number


      if(this.data.type=="text"||this.data.type=="longtext"  || this.data.type=="listselect" || this.data.type=="multiselect")
        {
          if(!submission.submission_text || submission.submission_text=="[]")
          {
            return false
          }         
          else
          {
            return true
          }
          
        }


        if( this.data.type=="columns" )
        {
          if(submission.submission_text)
          {
            let submission_parsed = JSON.parse(submission.submission_text)  
            let input_columns = this.data.columns.filter((thecolumn)=>{return thecolumn.type!=="readonly"})  
            if(submission_parsed.length === input_columns.length)
            {
              if (submission_parsed.some(element => !element.value)) 
              {
                  return false
              }
              else
              {
                  return true
              }             

            }
            
          }
          
        }



        if(this.data.type=="select" )
        {
          if(submission.submission_option || submission.submission_option!=="")
          {
            return true
          }
          else
          {
            return false
          }
          
        }


        if(this.data.type=="boolean")
        {
          if(submission.submission_option===1)
          {
            return true
          }
          else if(submission.submission_option===0)
          {
            return true
          }
          else
          {
            return false
          }
          
        }



    },
    rightsideclass()
    {
      if(this.data.type=="columns" || this.data.type=="listselect" || this.data.type=="listinput" )
      {
        return "col-12 md:col-2"
      }
      else if(this.data.type=="select" || this.data.type=="multiselect" )
      {
        if(this.data.horizontal_select)
        {
          return "col-12 md:col-2"
        }
        else
        {
          return "col-12 md:col-3 md:col-offset-4"
        }
      }
      else
      {
        return "col-12 md:col-3 md:col-offset-4"
      }
    },
    leftsideclass()
    {
      if(this.data.type=="columns" || this.data.type=="listselect" || this.data.type=="listinput" )
      {
        return "col-12 md:col-10"
      }
      else if(this.data.type=="select" || this.data.type=="multiselect" )
      {
        if(this.data.horizontal_select)
        {
          return "col-12 md:col-10"
        }
        else
        {
          return "col-12 md:col-5"
        }
      }
      else
      {
        return "col-12 md:col-5"
      }
    },
    evindence_ready()
    {
      if(this.data.submissions.length)
      {
        let item = this.data
        let submission = this.data.submissions[0]
        //number
        if(item.type=="number" )
        {
          if(submission.submission_numerical)
          {           
            
              return true
          }
          else
          {
              return false
          }
        }
        //number
        //text
        if(item.type=="text"||item.type=="longtext"  || item.type=="listselect" )
        {
          if(!submission.submission_text || submission.submission_text=="[]")
          {
              return false
          }         
          else
          {
              return true
          }
        }
        //text
        //type- columns
        if( item.type=="columns" )
        {
          if(submission.submission_text)
          {
            let submission_parsed = JSON.parse(submission.submission_text)                
            if(submission_parsed.length === item.columns.length)
            {
              if (submission_parsed.some(element => !element.value)) 
              {
                  return false
              }
              else
              {
                  return true
              }
              

            }
            
          }
          
        }
        //type- columns
        //type- select,boolean
        if(item.type=="select" || item.type=="boolean")
        {
          if(submission.submission_option)
          {
            return true
          }
          else
          {
            return false
          }
          
        }
        //type- select,boolean

      }
    },
    completion_class()
    {
      if(this.data.completion && this.data.is_required)
      {
        return "quiz_label_completed"
      }
      else if(!this.data.completion && !this.data.is_required)
      {
        return "quiz_label"
      }
      else if(this.data.completion && !this.data.is_required)
      {
        return "quiz_label_completed"
      }
      else
      {
        return "quiz_label"
      }
    },
    labelstatus()
    {
      let submission_done = this.data.submissions.length
      let completion = this.data.completion
      let is_required = this.data.is_required

      if(submission_done && completion && is_required)
      {
        return "submitted_completed_required"
      }

      if(!submission_done && completion && is_required)
      {
        return "notsubmitted_completed_required"
      }

      if(submission_done && !completion && is_required)
      {
        return "submitted_notcompleted_required"
      }

      if(submission_done && completion && !is_required)
      {
        return "submitted_completed_notrequired"
      }

      if(!submission_done && !completion && is_required)
      {
        return "notsubmitted_notcompleted_required"
      }
      if(!submission_done && completion && !is_required)
      {
        return "notsubmitted_completed_notrequired"
      }
      if(submission_done && !completion && !is_required)
      {
        return "submitted_notcompleted_notrequired"
      }
      if(!submission_done && !completion && !is_required)
      {
        return "notsubmitted_notcompleted_notrequired"
      }

    },
    labeltext()
    {
      if(this.data.translations.length)
      {
        let translation = this.data.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
        if(translation)
        {
          return translation.translation
        }
        else
        {
          return this.data.name
        }
        
      }
      else
      {
        return this.data.name
      }
      
    },
    helptext()
    {
      if(this.data.translations.length)
      {
        let translation = this.data.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
        if(translation && translation.description)
        {
          return translation.description
        }
        else
        {
          return ""
        }
      }
      else
      {
        return ""
      }
      
    },
    function_btn_adjust()
    {
      if(this.data.type=='columns')
      {
        return "inputfield_function_column_adjust_btn"
      }
      else
      {
        return ""
      }
    },
    inputfieldhightlight()
    {
      if(this.$store.state.evaluation.first_inputfield_error && this.$store.state.evaluation.first_inputfield_error.id == this.data.id)
      {

        
        
        setTimeout(()=>{
          let element = document.getElementById("inputfield_"+this.data.id)
          element.scrollIntoView({block: "center", inline: "nearest",behavior :"smooth"});
        },50)
        setTimeout(()=>{
          this.$store.state.evaluation.first_inputfield_error = null
        },5000)
        return "inputfield_highlight"
      }
      else
      {
        return ""
      }
    },
    finish_error()
    {
      
        this.$store.state.evaluation.finish_error
    }
  },
  mounted()
  {
  },
  methods:{
    testpoints()
    {
      console.log("inputfieldclasses")
      console.log(this.data)
    },
    nonconformityAdded(data)
    {
      console.log(data)
      let formdata = new FormData()
      formdata.append("flowsupplier_id",this.$store.state.audit.audit.flowsupplier.uuid)
      formdata.append("nonconformitytype_id",data.value)
      this.$store.dispatch('evaluation/setInputfieldsUpdating',true)
      this.generalSubmission(formdata,"audit/submit_nonconformity/"+this.data.id,this.aftersubmitNullWithoutReason)
    },
    removeNonconformity()
    {
      let formdata = new FormData()
      this.$store.dispatch('evaluation/setInputfieldsUpdating',true)
      this.generalSubmission(formdata,"audit/remove_nonconformity/"+this.data.nonconformity.id,this.aftersubmitNullWithoutReason)
    },
    addAuditorNote(data)
    {
      let formdata = new FormData()
      formdata.append("flowsupplier_id",this.$store.state.audit.audit.flowsupplier.uuid)
      formdata.append("auditor_note",data.value)
      this.$store.dispatch('evaluation/setInputfieldsUpdating',true)
      this.generalSubmission(formdata,"audit/submit_auditor_note/"+this.data.id,this.aftersubmitNullWithoutReason)
    },

    showEvidenceModal()
    {
      this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
      this.$store.dispatch('evaluation/setEvidenceModal',true)
    },
    showNullModal()
    {
      if(this.data.is_null_reason_required)
      {
        this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
        this.$store.dispatch('evaluation/setNullModal',true)
      }
      else
      {
        this.submitNullWithoutReason()
      }
       
    },
    submitNullWithoutReason()
    {
      let formdata = new FormData()
      formdata.append("flowsupplier_id",this.$store.state.audit.audit.flowsupplier.uuid)
      this.submitting_null = true
      //return false
      this.$store.dispatch('evaluation/setInputfieldsUpdating',true)
      this.generalSubmission(formdata,"audit/submit_inputfield_null_reason/"+this.data.id,this.aftersubmitNullWithoutReason)
    },
    aftersubmitNullWithoutReason(response)
    {
      this.afterSubmitAuditInputData(response)
      this.submitting_null = false
    },
    reverseNull()
    {
      this.dispatch = true
      let formdata = new FormData()
      formdata.append("flowsupplier_id",this.$store.state.audit.audit.flowsupplier.uuid)
      //return false
      this.$store.dispatch('evaluation/setInputfieldsUpdating',true)
      this.generalSubmission(formdata,"audit/reverse_inputfield_null_reason/"+this.data.id,this.afterreverseNull)
    },
    afterreverseNull(response)
    {
      this.afterSubmitAuditInputData(response) 
      this.calculateEvaluationProgress("first_init") 
    },
  }
}
</script>

<style lang="css" >
  .p-tooltip.help-tooltip{
    max-width: 45rem;
  }
  @media only screen
and (max-width : 768px) {
.p-tooltip.help-tooltip{
    max-width: 35rem;
  }

}
</style>